<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "EngConsumablesTableConfig",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    };
  },
  created() {

  },
  methods: {
   
  }
};
</script>

